import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get accountGroup
export const getAccountGroup = createAsyncThunk("accountGroup/getAccountGroup", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getAccountGroup({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all accountGroup
export const getAllAccountGroup = createAsyncThunk(
  "accountGroup/getAllAccountGroup",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllAccountGroup();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("accountGroup/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("accountGroup/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "accountGroup/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageAccountGroup({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const getAccountGroupById = createAsyncThunk(
  "accountGroup/getAccountGroupById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getAccountGroupById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create accountGroup
export const createAccountGroup = createAsyncThunk(
  "accountGroup/createAccountGroup",
  async (data, { rejectWithValue }) => {
    const { name, accountType, parent, isActive, isControlAccount, remarks } = data;
    try {
      const body = JSON.stringify({ name, accountType, parent, isControlAccount, isActive, remarks });
      const { data } = await API.createAccountGroup(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateAccountGroup = createAsyncThunk(
  "accountGroup/updateAccountGroup",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, accountType, parent, isControlAccount, isActive, remarks } = values;
    try {
      const body = JSON.stringify({ name, accountType, parent, isControlAccount, isActive, remarks });
      const { data } = await API.updateAccountGroup(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("accountGroup/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
